import { JoinSessionButtonWrapper } from '../JoinSessionButton';
import { MoodSurveyCta } from './MoodSurveyCta';
import { CTAProps, PreSessionPromptVariant } from './PreSessionPrompt';

export function JoinSessionCta({ openDrawer, state, variant }: CTAProps) {
  return (
    <div className='flex flex-col gap-4 mt-4'>
      <JoinSessionButtonWrapper />
      {/**
       * By design, to limit distractions, only the mood survey CTA is supported
       * as of 2025-01-13.
       */}
      {variant === PreSessionPromptVariant.MOOD_SURVEY && (
        <MoodSurveyCta use='secondary' openDrawer={openDrawer} state={state} variant={variant} />
      )}
    </div>
  );
}
